import styled from "styled-components"
import { Button } from "../../../ui/button"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../../ui/select"
import { Checkbox } from "../../../ui/checkbox"
import { Input } from '../../../ui/input'
import { useState } from "react"

const BarcodePrint = () => {

    const [showBarcode, setShowBarcode] = useState(false)

    const handleBarcodeFormat = (value) => {
        console.log(value)
    }

    return (
        <MainContainer>
            <ContainerForm>
                <Title>條碼生成</Title>
                <SubTitle>條碼格式</SubTitle>
                <Select onValueChange={e => { handleBarcodeFormat(e) }} >
                    <SelectTrigger className="w-[180px]">
                        <SelectValue placeholder="格式選擇" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="Code39" >Code39</SelectItem>
                        <SelectItem value="COOP2of5">COOP2of5</SelectItem>
                        <SelectItem value="EAN13">EAN13</SelectItem>
                    </SelectContent>
                </Select>
                <SmallFlexBox>
                    <SubTitle>顯示數字</SubTitle>
                    <Checkbox />
                </SmallFlexBox>
                <SubTitle>條碼高度(px)</SubTitle>
                <Em10>
                    <Input />
                </Em10>
                <SubTitle>條碼碼號</SubTitle>
                <Em20>
                    <Input />
                    <PScontext>
                        條碼必須由數字組成(0~9)
                    </PScontext>
                </Em20>
                <Button onClick={e => setShowBarcode(!showBarcode)} >
                    產生條碼
                </Button>
            </ContainerForm>
            <ContainerBarcode>
                {
                    showBarcode ?
                        <ColumnFlexBox>
                            <BarcodeImg
                                style={{
                                    height: 200
                                }}
                                src="https://i.pinimg.com/736x/32/12/1c/32121c4420d42b99ab213a20dbb82e04.jpg"
                            />
                            <Input readonly value='https://i.pinimg.com/736x/32/12/1c/32121c4420d42b99ab213a20dbb82e04.jpg' />
                        </ColumnFlexBox>
                        :
                        <></>
                }
            </ContainerBarcode>
        </MainContainer>
    )
}


const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
-ms-flex-direction: column;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
flex-wrap: wrap;
`

const ContainerForm = styled.div`
display: flex;
flex-direction: column;
gap: inherit;
}
`

const ContainerBarcode = styled.div`
`

const BarcodeImg = styled.img`
`


const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 600;
}
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
`

const Em20 = styled.div`
width: 20em;
`

export default BarcodePrint